module.exports = __webpack_public_path__ + "static/aleksandra_hero-23aa2753abc5c67aeb410ee4051c05aa.png";